import { CardContent } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import { OutlinedMediaLinkCard } from '../../ui-parts/OutlinedMediaLinkCard';
import ServiceLv1MetadataCard from './ServiceLv1MetadataCard';

// 2024.9.16 MyMine Version2.0対応 Modify Start
export const ServiceLv1ServiceOperationalCard = ({ screenId, navigateServiceLv2, controlSettings }) => {

  const processContentsList =
    [
      {
        caption: controlSettings.LabelList.lblPreDelivery,
        mediaImageFileName: controlSettings.ImageList.imgPreDelivery,
        description: controlSettings.LabelList.lblPreDeliveryDescription,
        navigateTo: 'MyM321'
      },
      {
        caption: controlSettings.LabelList.lblPostDelivery,
        mediaImageFileName: controlSettings.ImageList.imgPostDelivery,
        description: controlSettings.LabelList.lblPostDeliveryDescription,
        navigateTo: 'MyM322'
      },
    ];

  return (
    <ServiceLv1MetadataCard>
      <CardContent className='py-2 h-100' >
        <Grid container spacing={2} className='mt-0 h-100'>
          {processContentsList.map((processContents, i) =>
            <Grid item xs={12} md={6} key={i}>
              <OutlinedMediaLinkCard
                screenId={screenId}
                mediaHeight={170}
                descriptionHeight={270}
                {...processContents} />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </ServiceLv1MetadataCard>
  )
}
// 2024.9.16 MyMine Version2.0対応 Modify End
